import React, { useState, useEffect, useRef } from 'react'
import '../components-css/consult-with-omkatech.scss'
import axios from 'axios'
import { BASE_URL } from '../config'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import AOS from 'aos'
import 'aos/dist/aos.css'

const SITE_KEY = '6LebgI4rAAAAAPhRn6VH0DW687PInYqxB8BPxsXE'

const ConsultWithOmkatech = () => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    AOS.init({ duration: 1000, once: true, offset: 50 })
  }, [])
  const inputRef = useRef(null);

  const handleSend = () => {
    if (!inputRef.current.checkValidity()) {
      inputRef.current.reportValidity();
      return;
    }

    sendEmail();
  };

  const sendEmail = async () => {
    // Validation
    if (!email) {
      toast.error('Email Address is required', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      })
      return
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
      toast.error('Please enter a valid email address', {
        position: "top-right",
        autoClose: 3000,
      })
      return
    }

    setIsLoading(true)

    try {
      let token = null

      // Try to get reCAPTCHA token
      if (window.grecaptcha) {
        try {
          token = await window.grecaptcha.execute(SITE_KEY, {
            action: 'submit',
          })
        } catch (recaptchaError) {
          console.warn('reCAPTCHA error:', recaptchaError)
        }
      }

      const payload = {
        email,
        recaptchaToken: token,
      }

      const response = await axios.post(
        `${BASE_URL}/consult-with-us`,
        payload
      )

      if (response.data?.status === true) {
        setEmail('')
        toast.success(response.data.message || 'Email sent successfully!', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
      } else {
        toast.error(response.data?.message || 'Something went wrong', {
          position: "top-right",
          autoClose: 3000,
        })
      }
    } catch (error) {
      console.error('Error:', error)
      toast.error(
        error.response?.data?.message || error.message || 'Failed to send email',
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      )
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      {/* ✅ Toast Container - Outside main container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{ zIndex: 99999 }}
      />

      <div className='consult-main-container' data-aos='fade-top'>
        <div className='top-footer-part'>
          <h2>Consult with <b>OMKA TECH!</b></h2>
          <p>
            Book Your First Presentation with Our <b>Experts Today.</b>
          </p>

          <div className='input-container'>
            <input
              ref={inputRef}
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder='Email Address'
              disabled={isLoading}
              required
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !isLoading) {
                  handleSend();
                }
              }}
            />

            <button
              disabled={isLoading}
              onClick={handleSend}
            >
              {isLoading ? 'Sending...' : 'Send'}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ConsultWithOmkatech